var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_vm._t("position-left"),_c('notifications',{staticClass:"header__item"}),_c('user-menu',{staticClass:"header__item"}),_c('lang-select',{staticClass:"header__item"}),_vm._t("position-right")],2)}
var staticRenderFns = []

export { render, staticRenderFns }